import React from "react";
import { Button, Modal } from "semantic-ui-react";

interface SimpleOkCancelProps {
	open: boolean; // current open/closed state
	headerMsg: string; // message in header (short)
	bodyMsg: string; // description message in body (longer)
	onOk: () => void; // called when Ok button pressed
	onCancel: () => void; // called when Cancel button pressed

	// optional props
	onOpen?: () => void; // called when trigger fires onClick (optional)
	trigger?: React.ReactNode; // optional element with an onClick callback, ex: Button.
}

/**
 * Simple confirmation dialog wraps semantic-ui's Modal. Interaction is strict: forces user to pick OK or Cancel.
 */
const SimpleOkCancelModal = ({ open, trigger, headerMsg, bodyMsg, onOk, onCancel, onOpen }: SimpleOkCancelProps) => {
	if (trigger && !onOpen) {
		console.warn("Check configuration of SimpleOkCancelModal");
	}
	return (
		<>
			{!!trigger && !!onOpen && React.cloneElement(trigger as React.ReactElement, { onClick: onOpen })}
			<Modal open={open} onOpen={onOpen} closeOnDimmerClick={false} closeOnEscape={false}>
				<Modal.Header>{headerMsg}</Modal.Header>
				<Modal.Content>
					<Modal.Description>{bodyMsg}</Modal.Description>
				</Modal.Content>
				<Modal.Actions>
					<Button onClick={onCancel}>Cancel</Button>
					<Button floated="right" primary onClick={onOk}>
						OK
					</Button>
				</Modal.Actions>
			</Modal>
		</>
	);
};

export default SimpleOkCancelModal;
